const renderTableScore = (h, {
    props, parent, _v, data, tableClasses,
}) => {
    const renderTopic = (item) => {
        if (item.params && item.params.header) {
            return h(
                'td',
                { class: 'border border-50 text-left p-2' },
                parent.$t('Header'),
            );
        }
        return h('td', { class: 'text-left p-2' }, item.title || '-');
    };

    return h('table', { ...data, class: `w-full ${tableClasses}` }, [
        h('thead', {}, [
            h('tr', {}, [
                h(
                    'th',
                    { class: 'border border-50 text-left p-2' },
                    parent.$t('Topics'),
                ),
                h(
                    'th',
                    { class: 'border border-50 text-right p-2' },
                    parent.$t('Achieved score'),
                ),
                h(
                    'th',
                    { class: 'border border-50 text-right p-2' },
                    parent.$t('Potential score'),
                ),
                h(
                    'th',
                    { class: 'border border-50 text-right p-2' },
                    parent.$t('Result'),
                ),
            ]),
        ]),
        h(
            'tbody',
            {},
            props.resource.form.items
                .filter(
                    (item) => !(
                        item.params
                        && item.params.header
                        && !item.max_score
                        && item.max_score <= 0
                    ),
                )
                .map((item) => h('tr', { class: 'border border-50' }, [
                    renderTopic(item),
                    h(
                        'td',
                        { class: 'border border-50 text-right p-2' },
                        item.max_score > 0 ? item.score : '-',
                    ),
                    h(
                        'td',
                        { class: 'border border-50 text-right p-2' },
                        item.max_score > 0 ? item.max_score : '-',
                    ),
                    h(
                        'td',
                        { class: 'border border-50 text-right p-2' },
                        item.max_score > 0
                            ? parent.$n(
                                item.percentage / 100,
                                'scorePercentage',
                            )
                            : '-',
                    ),
                ])),
        ),
        h('tfoot', {}, [
            h('tr', { class: 'font-semibold' }, [
                h(
                    'td',
                    { class: 'border border-50 text-left p-2' },
                    parent.$t('Total'),
                ),
                h(
                    'td',
                    { class: 'border border-50 text-right p-2' },
                    props.resource.form.max_score > 0
                        ? props.resource.form.score
                        : '-',
                ),
                h(
                    'td',
                    { class: 'border border-50 text-right p-2' },
                    props.resource.form.max_score > 0
                        ? props.resource.form.max_score
                        : '-',
                ),
                h('td', { class: 'border border-50 text-right py pr-2' }, [
                    _v(
                        props.resource.form.max_score > 0
                            ? parent.$n(
                                props.resource.percentage / 100,
                                'scorePercentage',
                            )
                            : '-',
                    ),
                ]),
            ]),
        ]),
    ]);
};

export default {
    functional: true,
    name: 'ScoreTable',
    props: {
        resource: {
            type: Object,
            default: null,
        },
    },
    render(h, {
        props, data, parent, _v,
    }) {
        if (
            typeof props.resource.percentage === 'undefined'
            || props.resource.percentage === null
            || !props.resource.template.display_score_result_of_pages
            || !props.resource.max_score
        ) {
            return null;
        }

        const tableClasses = data.class ? `border-none ${data.class}` : '';
        return renderTableScore(h, {
            props,
            parent,
            _v,
            data,
            tableClasses,
        });
    },
};
